(() => {
  if (window.McPettyPetLexicon) { window.McPettyPetLexicon.start(); return; }
  const dayMs = 86400000;
  const instances = new Map();
  let selectedBlock = null;
  const indexAt = (now, epoch, count) => count > 0 ? Math.max(0, Math.floor((now - epoch) / dayMs)) % count : 0;
  const create = (root) => {
    let timer;
    const epoch = Number(root.dataset.lexiconEpoch) || 0;
    const update = () => {
      clearTimeout(timer);
      if (!root.isConnected) return;
      const entries = [...root.querySelectorAll('[data-pet-term]')];
      if (!entries.length) return;
      const preview = selectedBlock ? entries.findIndex(entry => entry.dataset.blockId === selectedBlock) : -1;
      const position = preview >= 0 ? preview : indexAt(Date.now(), epoch, entries.length);
      entries.forEach((entry, i) => { entry.hidden = i !== position; });
      root.dataset.currentTerm = String(position);
      if (preview >= 0) return;
      const now = Date.now();
      const delay = now < epoch ? epoch + dayMs - now : dayMs - ((now - epoch) % dayMs);
      timer = setTimeout(update, Math.min(2147483647, Math.max(1, delay)));
    };
    update();
    return { update, destroy: () => clearTimeout(timer) };
  };
  const start = () => {
    for (const [root, controller] of instances) {
      if (!root.isConnected) { controller.destroy(); instances.delete(root); }
    }
    document.querySelectorAll('[data-pet-lexicon]').forEach(root => {
      if (!instances.has(root)) instances.set(root, create(root));
      else instances.get(root).update();
    });
  };
  window.McPettyPetLexicon = { start, indexAt };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) instances.forEach(controller => controller.update()); });
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [root, controller] of instances) {
      if (event.target.contains(root)) { controller.destroy(); instances.delete(root); }
    }
  });
  document.addEventListener('shopify:block:select', (event) => {
    const entry = event.target.closest?.('[data-pet-term]');
    selectedBlock = event.detail?.blockId || entry?.dataset.blockId || null;
    instances.forEach(controller => controller.update());
  });
  document.addEventListener('shopify:block:deselect', () => { selectedBlock = null; instances.forEach(controller => controller.update()); });
})();
